import {ICreatePatientPrescription} from 'core/api/patient/prescription'
import {Eye, IPrescriptionTemplate} from 'core/api/prescription'
import {PrescriptionTemplatesByKey} from './templates'

export const buildPrescriptionFromTemplate = (
  prescriptionTemplate: IPrescriptionTemplate,
  {amblyopicEye}: {amblyopicEye: Eye},
): ICreatePatientPrescription => {
  // tslint:disable-next-line no-unused-variable
  const {name, key, ...namelessPrescriptionTemplate} = prescriptionTemplate
  return {
    ...namelessPrescriptionTemplate,
    amblyopicEye,
  }
}

export const buildPrescriptionFromTemplateKey = (
  prescriptionTemplateKey: string,
  {amblyopicEye}: {amblyopicEye: Eye},
): ICreatePatientPrescription | undefined => {
  const template = PrescriptionTemplatesByKey[prescriptionTemplateKey]
  if (!template) return undefined
  return buildPrescriptionFromTemplate(template, {amblyopicEye})
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/prescription/create.ts